import API from "../../../../../../utils/apiCalling";

import {
    config,
} from "../../../../../../utils/apiUrl";


const api =
    new API();


/*
|--------------------------------------------------------------------------
| EMPLOYEE MASTER
|--------------------------------------------------------------------------
*/

export const employeeApi = {

    getDropdownData:
        () =>
            api.get(
                config.employeeDropdownData
            ),


    getEmployees:
        (
            payload
        ) =>
            api.post(
                config.getEmployees,
                payload
            ),


    getEmployeeById:
        (
            id
        ) =>
            api.get(
                config.getEmployeeById(
                    id
                )
            ),


    createEmployee:
        (
            formData
        ) =>
            api.postFormData(
                config.createEmployee,
                formData
            ),


    updateEmployee:
        (
            id,
            formData
        ) =>
            api.put(
                config.updateEmployee(
                    id
                ),
                formData
            ),


    changeStatus:
        (
            id,
            payload
        ) =>
            api.patch(
                config.changeEmployeeStatus(
                    id
                ),
                payload
            ),


    toggleLoginAccess:
        (
            id,
            payload
        ) =>
            api.patch(
                config.toggleEmployeeLoginAccess(
                    id
                ),
                payload
            ),

};


/*
|--------------------------------------------------------------------------
| SALARY
|--------------------------------------------------------------------------
*/

export const employeeSalaryApi = {

    getList:
        (
            payload
        ) =>
            api.post(
                config.getEmployeeSalaries,
                payload
            ),


    getSummary:
        (
            params = {}
        ) =>
            api.get(
                config.getEmployeeSalarySummary,
                params
            ),


    getById:
        (
            id
        ) =>
            api.get(
                config.getEmployeeSalaryById(
                    id
                )
            ),


    generate:
        (
            payload
        ) =>
            api.post(
                config.generateEmployeeSalary,
                payload
            ),


    update:
        (
            id,
            payload
        ) =>
            api.put(
                config.updateEmployeeSalary(
                    id
                ),
                payload
            ),


    pay:
        (
            id,
            payload
        ) =>
            api.post(
                config.payEmployeeSalary(
                    id
                ),
                payload
            ),


    getPayments:
        (
            id
        ) =>
            api.get(
                config.getEmployeeSalaryPayments(
                    id
                )
            ),


    cancel:
        (
            id,
            payload
        ) =>
            api.patch(
                config.cancelEmployeeSalary(
                    id
                ),
                payload
            ),

};


/*
|--------------------------------------------------------------------------
| ADVANCE
|--------------------------------------------------------------------------
*/

export const employeeAdvanceApi = {

    getList:
        (
            payload
        ) =>
            api.post(
                config.getEmployeeAdvances,
                payload
            ),


    getSummary:
        (
            params = {}
        ) =>
            api.get(
                config.getEmployeeAdvanceSummary,
                params
            ),


    getById:
        (
            id
        ) =>
            api.get(
                config.getEmployeeAdvanceById(
                    id
                )
            ),


    create:
        (
            payload
        ) =>
            api.post(
                config.createEmployeeAdvance,
                payload
            ),


    update:
        (
            id,
            payload
        ) =>
            api.put(
                config.updateEmployeeAdvance(
                    id
                ),
                payload
            ),


    recover:
        (
            id,
            payload
        ) =>
            api.post(
                config.recoverEmployeeAdvance(
                    id
                ),
                payload
            ),


    getRecoveries:
        (
            id
        ) =>
            api.get(
                config.getEmployeeAdvanceRecoveries(
                    id
                )
            ),


    cancel:
        (
            id,
            payload
        ) =>
            api.patch(
                config.cancelEmployeeAdvance(
                    id
                ),
                payload
            ),

};


/*
|--------------------------------------------------------------------------
| LEAVE TYPE
|--------------------------------------------------------------------------
*/

export const employeeLeaveTypeApi = {

    getList:
        () =>
            api.get(
                config.getEmployeeLeaveTypes
            ),


    create:
        (
            payload
        ) =>
            api.post(
                config.createEmployeeLeaveType,
                payload
            ),


    update:
        (
            id,
            payload
        ) =>
            api.put(
                config.updateEmployeeLeaveType(
                    id
                ),
                payload
            ),


    remove:
        (
            id
        ) =>
            api.delete(
                config.deleteEmployeeLeaveType(
                    id
                )
            ),

};


/*
|--------------------------------------------------------------------------
| LEAVE
|--------------------------------------------------------------------------
*/

export const employeeLeaveApi = {

    getList:
        (
            payload
        ) =>
            api.post(
                config.getEmployeeLeaves,
                payload
            ),


    create:
        (
            payload
        ) =>
            api.post(
                config.createEmployeeLeave,
                payload
            ),


    getById:
        (
            id
        ) =>
            api.get(
                config.getEmployeeLeaveById(
                    id
                )
            ),


    approve:
        (
            id
        ) =>
            api.patch(
                config.approveEmployeeLeave(
                    id
                ),
                {}
            ),


    reject:
        (
            id,
            payload
        ) =>
            api.patch(
                config.rejectEmployeeLeave(
                    id
                ),
                payload
            ),


    cancel:
        (
            id,
            payload
        ) =>
            api.patch(
                config.cancelEmployeeLeave(
                    id
                ),
                payload
            ),


    getBalances:
        (
            employeeId,
            year
        ) =>
            api.get(
                config.getEmployeeLeaveBalances(
                    employeeId,
                    year
                )
            ),

};


/*
|--------------------------------------------------------------------------
| ATTENDANCE
|--------------------------------------------------------------------------
*/

export const employeeAttendanceApi = {

    getList:
        (
            payload
        ) =>
            api.post(
                config.getEmployeeAttendance,
                payload
            ),


    save:
        (
            payload
        ) =>
            api.post(
                config.saveEmployeeAttendance,
                payload
            ),


    bulkSave:
        (
            payload
        ) =>
            api.post(
                config.saveBulkEmployeeAttendance,
                payload
            ),


    getSummary:
        (
            employeeId,
            year,
            month
        ) =>
            api.get(
                config.getEmployeeAttendanceSummary(
                    employeeId,
                    year,
                    month
                )
            ),


    remove:
        (
            id
        ) =>
            api.delete(
                config.deleteEmployeeAttendance(
                    id
                )
            ),

};

/* OFFER & ONBOARDING */
export const employeeOfferApi = {
  getDropdownData: () => api.get(config.getEmployeeOfferDropdownData),
  getList: (payload) => api.post(config.getEmployeeOffers, payload),
  create: (employeeId, payload) => api.post(config.createEmployeeOffer(employeeId), payload),
  getById: (id) => api.get(config.getEmployeeOfferById(id)),
  getLink: (id) => api.get(config.getEmployeeOfferLink(id)),
  regenerateLink: (id, payload = {}) => api.post(config.regenerateEmployeeOfferLink(id), payload),
  sendEmail: (id, payload = {}) => api.post(config.sendEmployeeOfferEmail(id), payload),
  verify: (id) => api.patch(config.verifyEmployeeOffer(id), {}),
  sendCredentials: (id, payload) => api.post(config.sendEmployeeCredentials(id), payload),
  cancel: (id) => api.patch(config.cancelEmployeeOffer(id), {}),
};
